import api from './client';

export interface SymptomDefinition {
  id: string;
  label: string;
  system: string;
  synonyms: string[];
  specificity: number;
  emergency?: boolean;
  description?: string;
}

export interface RankedDifferential {
  diseaseId?: number;
  diseaseName: string;
  category: string;
  matchScore: number;
  matchPercentage: number;
  matchedSymptoms: string[];
  keySymptomsMatched: string[];
  missingKeySymptoms: string[];
  severity: string;
  mortality: string;
  contagious: boolean;
  zoonotic: boolean;
  affectedSystems: string[];
  diagnosticSteps: string[];
  ruleOutTests: string[];
  immediateActions: string[];
  source: string;
}

export interface DifferentialDiagnosisResult {
  triage: {
    emergencySymptoms: string[];
    requiresImmediateVet: boolean;
    triageMessage: string;
  };
  observedSymptoms: Array<{ id: string; label: string; system: string }>;
  bodySystemsInvolved: string[];
  differentials: RankedDifferential[];
  protocol: Array<{ phase: string; title: string; description: string; actions: string[] }>;
  recommendedNextSteps: string[];
  husbandryReview: string[];
}

export const differentialDiagnosisApi = {
  getCatalog: async () => {
    const response = await api.get<{
      symptoms: SymptomDefinition[];
      bySystem: Record<string, SymptomDefinition[]>;
      systemLabels: Record<string, string>;
      protocol: DifferentialDiagnosisResult['protocol'];
      checklistMap: Record<string, string[]>;
    }>('diseases/symptoms/catalog');
    return response.data;
  },

  compute: async (payload: {
    symptomIds: string[];
    freeTextSymptoms?: string[];
    checklistItemIds?: string[];
    bodySystems?: string[];
  }) => {
    const response = await api.post<DifferentialDiagnosisResult>('diseases/differential', payload);
    return response.data;
  },
};
